"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AppConstants = _interopRequireDefault(require("../../constants/AppConstants"));
var _ApiConstants = _interopRequireDefault(require("../../constants/ApiConstants"));
var _AppUtil = require("../../util/AppUtil");
var _ServiceRegistry = _interopRequireDefault(require("../../util/ServiceRegistry"));
var _CallbackTypes = _interopRequireDefault(require("../../constants/CallbackTypes"));
var _LoggingService = require("../../service/LoggingService");
var _saveFile = _interopRequireDefault(require("./saveFile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const updateFile = (options = {}, saveType = _AppConstants.default.SAVE_COMMENT_TYPE.MANUAL) => new Promise((res, reject) => {
  const appStore = _ServiceRegistry.default.getService("AppStore");
  const fileMetadata = appStore.fileInfoList[0].metaData;
  const pollingService = _ServiceRegistry.default.getService("PollingService");
  pollingService.stopPolling();
  appStore.previewRef.getApis("INTEGRATION_CONNECTOR", ["document"]).then(apiObject => {
    if (appStore.getActionConfig("preview").enableCNPDF) {
      apiObject.document.getCNPDFUpdates().then(cnpdfUpdates => {
        const callbackService = _ServiceRegistry.default.getService("CallbackService");
        const saveCallback = callbackService.getCallback(_CallbackTypes.default.SAVE_API);
        saveCallback(cnpdfUpdates).then(res).catch(reject);
      });
    } else {
      apiObject.document.getUpdatedPDFBuffer(appStore.configStore.getSaveCallbackConfig().incremental).then(buffer => {
        const st = new Date().getTime();
        const size = buffer.length;
        const saveAs = !!options.updated;
        const saveCommentStatusLogging = message => {
          const et = new Date().getTime();
          const _loggingService = _ServiceRegistry.default.getService("LoggingService");
          _loggingService.emit("saveHandler", "info", message, {
            saveAs,
            saveType,
            size,
            st,
            et
          });
          const event = {
            workflow: "pdf",
            subcategory: "annotation",
            type: saveAs ? "conflict" : "save",
            subtype: saveType
          };
          const custom = {
            "adb.event.context.pdfviewer.file_size": size / 1024,
            "adb.event.context.pdfviewer.saveTime": (et - st) / 1000
          };
          _ServiceRegistry.default.getService("AnalyticsProviderService").logEvent(event, custom);
        };
        const callbackService = _ServiceRegistry.default.getService("CallbackService");
        const saveCallback = callbackService.getCallback(_CallbackTypes.default.SAVE_API);
        const params = {};
        if (saveAs) {
          params.saveAs = true;
        }
        saveCallback((0, _AppUtil.deepCopyObject)(fileMetadata), buffer, params).then(response => {
          if (response.code === _ApiConstants.default.API_RESPONSE.SUCCESS) {
            saveCommentStatusLogging(_LoggingService.LoggingConstants.SAVE_COMMENT);
            if (saveAs) {
              const getParent = () => {
                if (response.data && response.data.metaData) {
                  return response.data.metaData.parent || {};
                }
                return {};
              };
              const parentData = getParent();
              appStore.setToastInfo({
                type: _AppConstants.default.SHOW_TOAST.CONFLICT,
                data: parentData
              });
            }
            if (appStore.isDirty || appStore.configStore.getPollingConfig().keepPolling) {
              pollingService.startPolling();
            }
            res(response.data.metaData);
          }
          if (response.code === _ApiConstants.default.API_RESPONSE.FILE_MODIFIED) {
            appStore.setShowLoader(false);
            saveCommentStatusLogging(_LoggingService.LoggingConstants.SAVE_COMMENT_CONFLICT);
            const event = {
              workflow: "preview",
              subcategory: "updated save",
              type: "CONFLICT"
            };
            _ServiceRegistry.default.getService("AnalyticsProviderService").logEvent(event, {});
            _ServiceRegistry.default.getService("DialogApi").showConflictDialog(_objectSpread(_objectSpread({}, response.data.modifiedBy), {}, {
              onCancel: () => {
                appStore.setFileStatus(undefined);
                appStore.setIsDirty(true);
                (0, _saveFile.default)({
                  updated: true
                }, _AppConstants.default.SAVE_COMMENT_TYPE.AUTO_SAVE_CONFLICT_COPY).then(val => res(val)).catch(err => reject(err));
              }
            }));
          }
        }).catch(error => {
          _ServiceRegistry.default.getService("LoggingService").emit("saveHandler", "INFO", `Save comment failed ${JSON.stringify(error)}`, {});
          saveCommentStatusLogging(_LoggingService.LoggingConstants.SAVE_COMMENT_ERROR);
          reject(error);
        });
      });
    }
  });
});
var _default = exports.default = updateFile;